import request from '@/utils/request.js';

// 获取预览详情页帖子信息
export const getDetailTopicInfoPreview = (params) =>
  request({ url: '/v1/conversation/conversation_info', method: 'get', params });

// 996官网配置 - 获取活动信息
export const channelGame = (params) => request({ url: '/v1/channel_game', method: 'get', params });
// 996官网配置 - 996官网埋点数据上报 - http://doc.hzwxbz2.cn/web/#/1?page_id=1943
export const reportWebsiteData = (data) =>
  request({ url: '/v1/report_website/data', method: 'post', data });
